__turbopack_context__.v({
  "cell": "otp-input-module-scss-module__2jajSa__cell",
  "root": "otp-input-module-scss-module__2jajSa__root",
});
